export default __webpack_public_path__ + "static/media/minion.21403dcd.gif";